<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between mb-4">
			<h2 class="mb-4">Notification</h2>
			<div>
				<v-btn color="primary" @click="showAdd()">Add Notification</v-btn>
			</div>
		</div>
		<div>
			<v-card>
				<v-data-table v-model="entityList" :headers="headers" :items="entityList" :footer-props="{ itemsPerPageOptions: [50, 100, -1] }">
					<template v-slot:item.status="{ item }">
						{{ item.status ? "Done" : "Incoming" }}
					</template>
					<template v-slot:item.action="{ item }">
						<v-icon small class="mr-2" @click="showEdit(item)">mdi-pencil</v-icon>
						<v-icon small @click="deleteNotification(item.id)">mdi-delete</v-icon>
					</template>
				</v-data-table>
			</v-card>
		</div>
		<v-dialog v-model="dialogAdd" persistent no-click-animation max-width="600">
			<v-card tile>
				<v-card-title class="headline">
					Add Notification
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="ma-4"></v-divider>
				<v-card-text>
					<v-form ref="formAdd" v-model="valid" @submit.prevent="addNotification()">
						<v-menu ref="notifyDateAdd" v-model="isShowAddNotifyDate" :close-on-content-click="false" :return-value.sync="entityAdd.transitMap.notifyDate" transition="scale-transition" offset-y max-width="290px">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="entityAdd.transitMap.notifyDate"
									label="Notify Date Time"
									:rules="[(v) => !!v || 'Notify Date Time is required']"
									prepend-inner-icon="mdi-calendar-clock"
									v-bind="attrs"
									v-on="on"
									dense
									autocomplete="off"
									@click="resetTime"
									outlined
								></v-text-field>
							</template>
							<v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="entityAdd.transitMap.notifyDate" @input="entityAdd.transitMap.notifyDate = changeDatetime(entityAdd.transitMap.notifyDate)" color="primary" no-title>
								<div class="d-flex flex-column" style="width: 100%">
									<div class="d-flex flex-row align-space-arround">
										<span>Time</span>
										<v-select
											v-model="hour"
											:items="
												Array(24)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityAdd.transitMap.notifyDate = changeDatetime(entityAdd.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template> </v-select
										>:
										<v-select
											v-model="minute"
											:items="
												Array(60)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityAdd.transitMap.notifyDate = changeDatetime(entityAdd.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template> </v-select
										>:
										<v-select
											v-model="second"
											:items="
												Array(60)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityAdd.transitMap.notifyDate = changeDatetime(entityAdd.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template>
										</v-select>
									</div>
									<v-divider></v-divider>
									<div class="d-flex justify-end">
										<v-btn text color="primary" @click="isShowAddNotifyDate = false">Cancel</v-btn>
										<v-btn text color="primary" @click="$refs.notifyDateAdd.save((entityAdd.transitMap.notifyDate = changeDatetime(entityAdd.transitMap.notifyDate)))">OK</v-btn>
									</div>
								</div>
							</v-date-picker>
						</v-menu>
						<v-textarea
							v-model="entityAdd.message"
							label="Message"
							counter
							:rules="[(v) => !!v || 'Message is required', (v) => (!!v && v.length <= 200) || 'Max 200 characters']"
							prepend-inner-icon="mdi-message-text-outline"
							dense
							outlined
						></v-textarea>
						<v-select
							v-model="entityAdd.ticketTypeList"
							prepend-inner-icon="mdi-ticket-account"
							:items="ticketList"
							item-text="name"
							item-value="name"
							label="Ticket Types"
							hint="Add specific messages for individual ticket types (Optional). If empty it means all users will get the notification"
							persistent-hint
							dense
							outlined
							multiple
						></v-select>
						<div class="d-flex justify-end">
							<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogEdit" persistent no-click-animation max-width="600">
			<v-card tile>
				<v-card-title class="headline">
					Edit Notification
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form ref="formEdit" v-model="valid" @submit.prevent="editNotification()">
						<v-menu ref="notifyDateEdit" v-model="isShowEditNotifyDate" :close-on-content-click="false" :return-value.sync="entityEdit.transitMap.notifyDate" transition="scale-transition" offset-y max-width="290px">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="entityEdit.transitMap.notifyDate"
									label="Notify Date Time"
									:rules="[(v) => !!v || 'Notify Date Time is required']"
									prepend-inner-icon="mdi-calendar-clock"
									v-bind="attrs"
									v-on="on"
									dense
									autocomplete="off"
									@click="resetTime"
									outlined
								></v-text-field>
							</template>
							<v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="entityEdit.transitMap.notifyDate" @input="entityEdit.transitMap.notifyDate = changeDatetime(entityEdit.transitMap.notifyDate)" color="primary" no-title>
								<div class="d-flex flex-column" style="width: 100%">
									<div class="d-flex flex-row align-space-arround">
										<span>Time</span>
										<v-select
											v-model="hour"
											:items="
												Array(24)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityEdit.transitMap.notifyDate = changeDatetime(entityEdit.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template> </v-select
										>:
										<v-select
											v-model="minute"
											:items="
												Array(60)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityEdit.transitMap.notifyDate = changeDatetime(entityEdit.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template> </v-select
										>:
										<v-select
											v-model="second"
											:items="
												Array(60)
													.fill()
													.map((x, i) => ('' + i).padStart(2, '0'))
											"
											class="mx-2"
											style="width: 10px"
											dense
											append-icon="false"
											@input="entityEdit.transitMap.notifyDate = changeDatetime(entityEdit.transitMap.notifyDate)"
										>
											<template v-slot:selection="{ item }">
												<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
											</template>
										</v-select>
									</div>
									<v-divider></v-divider>
									<div class="d-flex justify-end">
										<v-btn text color="primary" @click="isShowEditNotifyDate = false">Cancel</v-btn>
										<v-btn text color="primary" @click="$refs.notifyDateEdit.save((entityEdit.transitMap.notifyDate = changeDatetime(entityEdit.transitMap.notifyDate)))">OK</v-btn>
									</div>
								</div>
							</v-date-picker>
						</v-menu>
						<v-textarea
							v-model="entityEdit.message"
							label="Message"
							counter
							:rules="[(v) => !!v || 'Message is required', (v) => (!!v && v.length <= 200) || 'Max 200 characters']"
							prepend-inner-icon="mdi-message-text-outline"
							dense
							outlined
						></v-textarea>
						<v-select
							v-model="entityEdit.ticketTypeList"
							prepend-inner-icon="mdi-ticket-account"
							:items="ticketList"
							item-text="name"
							item-value="name"
							label="Ticket Types"
							hint="Add specific messages for individual ticket types (Optional). If empty it means all users will get the notification"
							persistent-hint
							dense
							outlined
							multiple
						></v-select>
						<div class="d-flex justify-end">
							<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			baseLocation: axios.defaults.baseURL,
			valid: true,
			dialogAdd: false,
			dialogEdit: false,
			entityList: [],
			entityAdd: { transitMap: {} },
			entityEdit: { transitMap: {} },
			ticketList: [],
			hour: "00",
			minute: "00",
			second: "00",
			isShowAddNotifyDate: false,
			isShowEditNotifyDate: false,
			headers: [
				{ text: "Notify Date Time", value: "transitMap.notifyDate" },
				{ text: "Message", value: "message" },
				{ text: "Ticket Type", value: "ticketTypeList" },
				{ text: "Status", value: "status" },
				{ text: "Action", value: "action", sortable: false }
			]
		};
	},
	mounted() {
		this.listTicket();
		this.listNotification();
	},
	methods: {
		listNotification() {
			axios.post("/system/notification/list", { experienceId: this.experienceId }).then((response) => {
				this.entityList = response.data;
			});
		},
		listTicket() {
			axios.post("/system/ticket/list", { experienceId: this.experienceId }).then((response) => {
				this.ticketList = response.data;
			});
		},
		showAdd() {
			this.dialogAdd = true;
		},
		closeAdd() {
			this.dialogAdd = false;
			this.entityAdd = { transitMap: {} };
			this.$refs.formAdd.resetValidation();
		},
		showEdit(entity) {
			this.entityEdit = Object.assign({}, entity);
			this.dialogEdit = true;
		},
		closeEdit() {
			this.dialogEdit = false;
			this.entityEdit = { transitMap: {} };
			this.$refs.formEdit.resetValidation();
		},
		addNotification() {
			let formData = new FormData();
			this.entityAdd.experienceId = this.experienceId;
			formData.append("entity", JSON.stringify(this.entityAdd));
			axios.post("/system/notification/add", formData).then(() => {
				this.closeAdd();
				this.listNotification();
			});
		},
		editNotification() {
			let formData = new FormData();
			this.entityEdit.experienceId = this.experienceId;
			formData.append("entity", JSON.stringify(this.entityEdit));
			axios.post("/system/notification/edit", formData).then(() => {
				this.closeEdit();
				this.listNotification();
			});
		},
		deleteNotification(id) {
			axios.post("/system/notification/delete", { id: id }).then(() => {
				this.listNotification();
			});
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		changeDatetime: function (dateTime) {
			if (dateTime === undefined || dateTime === "") {
				return new Date().toISOString().substr(0, 10) + " " + this.hour + ":" + this.minute + ":" + this.second;
			} else {
				return dateTime.substr(0, 10) + " " + this.hour + ":" + this.minute + ":" + this.second;
			}
		}
	}
};
</script>